<style>
  nav {
    background-color: #ccc;
    display: flex;
    flex-flow: column;
    flex: 0 0 auto;
    overflow-x: auto;
  }
  div {
    display: flex;
    flex-flow: column;
    flex: 0 1 auto;
  }
  .flexible {
    flex: 1 1 auto;
  }
  @media screen and (max-width: 800px) {
    nav {
      flex-flow: row;
    }
    div {
      flex-flow: row;
    }
  }
</style>

<script>
  import config from '../../config';
  import NavButton from './NavButton.svelte';
</script>

<nav>
  <div>
    {#each config.nav.top as nav_id}
      <NavButton {nav_id}/>
    {/each}
  </div>
  <div class='flexible'>
    {#each config.nav.mid as nav_id}
      <NavButton {nav_id}/>
    {/each}
  </div>
  <div>
    {#each config.nav.bottom as nav_id}
      <NavButton {nav_id}/>
    {/each}
  </div>
</nav>
